module.exports = __webpack_public_path__ + "ath_game_web/img/5.3.293c39e1.png";